import { useSelector } from "react-redux";
import AdminTaskManager from "./components/AdminTaskManager";
import SuperAdminTaskManager from "./components/SuperAdminTaskManager";
import { Row, Col, Modal, Tabs, Tab, OverlayTrigger, Tooltip, Button } from "react-bootstrap";
import AdminLinksComponent from "../../components/admin/AdminLinksComponent";

const AdminTasksPage = () => {
  const { userInfo } = useSelector((state) => state.userRegisterLogin);

  return (
    <>
      <Row className="content-container m-5">
        <Col md={2}>
          <AdminLinksComponent />
        </Col>
        <Col md={10}>
          <div className="p-4">
            <h2>Admin Tasks Dashboard</h2>
            {userInfo?.isVIP ? (
              <SuperAdminTaskManager userInfo={userInfo} />
            ) : (
              <AdminTaskManager userInfo={userInfo} />
            )}
          </div>
        </Col>
      </Row>
    </>
  );
};

export default AdminTasksPage;
